export default {
    ADD_TEMPLATE_DATA ({ commit }, template) {
        commit('addTemplateData', template)
    },
    ADD_PROJECT_DATA ({ commit }, project) {
        commit('addProjectData', project)
    },
    SET_CURRENT_PAGE ({ commit }, currentPage) {
        commit('setCurrentPage', currentPage)
    },
    ADD_GALLERY_ELEMENT ({ commit }, element) {
        commit('addGalleryElement', element)
    },
    REMOVE_GALLERY_ELEMENT ({ commit }, element) {
        commit('removeGalleryElement', element)
    },
    ADD_NEW_PAGE ({ commit }, page) {
        commit('addNewPage', page)
    },
    REMOVE_PAGE ({ commit }, page) {
        commit('removePage', page)
    },
    SET_PAGE_COLOR ({ commit }, payload) {
        commit('setPageColor', payload)
    },
    SET_PAGE_RADIUS ({ commit }, payload) {
        commit('setPageRadius', payload)
    },
    LOCK_PAGE ({ commit }, payload) {
        commit('lockPage', payload)
    },
    SET_PAGE_BACKGROUND ({ commit }, payload) {
        commit('setPageBackground', payload)
    },
    REMOVE_PAGE_BACKGROUND ({ commit }) {
        commit('removePageBackground')
    },
    SLIDE_PAGE ({ commit }, payload) {
        commit('slidePage', payload)
    },
    ADD_PAGE_ELEMENT ({ commit }, element) {
        commit('addPageElement', element)
        // commit('changeActiveElement', element)
    },
    LOCK_PAGE_ELEMENT ({ commit }, payload) {
        commit('lockPageElement', payload)
    },
    REMOVE_PAGE_ELEMENT ({ commit }) {
        commit('removePageElement')
    },
    SAVE_PAGE_WEB_SIZE ({ commit }, payload) {
        commit('savePageWebSize', payload)
    },
    SAVE_PAGE_SIZE ({ commit }, payload) {
        commit('savePageSize', payload)
    },
    TOGGLE_ELEMENTS ({ commit }) {
        commit('toggleElements')
    },
    ADD_MOVEABLE_ELEMENT ({ commit }, element) {
        commit('addMoveableElement', element)
    },
    ACTIVATE_ELEMENT ({ commit }, element) {
        commit('activateElement', element)
    },
    DISABLE_ELEMENTS_ON_PAGE ({ commit }) {
        commit('disableElementsOnPage')
    },
    EDIT_IMAGE_ELEMENT_FILTERS ({ commit }, filter) {
        commit('editImageElementFilter', filter)
    },
    OPEN_MODAL ({ commit }, modalName) {
        commit('openGalleryModal', modalName)
    },
    CLOSE_MODAL ({ commit }, modalName) {
        commit('closeModal', modalName)
    },
    ELEMENT_COLOR ({ commit }, color) {
        commit('elementColor', color)
    },
    QR_ELEMENT_COLOR ({ commit }, payload) {
        commit('qrElementColor', payload)
    },
    ADD_COLOR_TO_LAST_USED({ commit }, payload) {
        commit('addColorToLastUsed', payload)
    },
    SET_TEXT_VARIABLE ({ commit }, payload) {
        commit('setTextVariable', payload)
    },
    SET_TEXT_PLACEHOLDER ({ commit }, payload) {
        commit('setTextPlaceholder', payload)
    },
    SET_PLACEHOLDERS ({ commit }, payload) {
        commit('setPlaceholders', payload)
    },
    SET_PLACEHOLDER_USER_INPUTS ({ commit }, payload) {
        commit('setPlaceholderUserInputs', payload)
    },
    SET_PLACEHOLDER_CONTENT ({ commit }, payload) {
        commit('setPlaceholderContent', payload)
    },
    CHANGE_TEXT ({ commit }, payload) {
        commit('changeText', payload)
    },
    CHANGE_TAB ({ commit }, payload) {
        commit('changeTab', payload)
    },
    CHANGE_ACTIVE_ELEMENT ({ commit }, payload) {
        commit('changeActiveElement', payload)
    },
    UPDATE_ELEMENT ({ commit }, payload) {
        commit('updateElement', payload)
    },
    UPDATE_THIS_ELEMENT ({ commit }, payload) {
        commit('updateThisElement', payload)
    },
    FLIP_ELEMENT ({ commit }, payload) {
        commit('flipElement', payload)
    },
    UPDATE_ALL_ELEMENTS({ commit }, payload) {
        commit('updateAllElements', payload)
    },
    SAVE_PROJECT ({ commit }) {
        commit('saveProject')
    },
    ADD_SESSION_DETAILS ({ commit }, payload) {
        commit('addSessionDetails', payload)
    },
    ADD_SESSION_TOKEN ({ commit }, payload) {
        commit('addSessionToken', payload)
    },
    SET_ACTIVE_THEME_TAB ({ commit }, payload) {
        commit('setActiveThemeTab', payload)
    },
    SET_ACTIVE_PROJECT_IN_THEME_TAB ({ commit }, payload) {
        commit('setActiveProjectInThemeTab', payload)
    },
    SET_ACTIVE_FORMAT_IN_THEME_TAB ({ commit }, payload) {
        commit('setActiveFormatInThemeTab', payload)
    },
    CLEAR_PAGE ({ commit }) {
        commit('clearPage');
    },
    SET_TEST_TOKEN({ commit }, payload) {
        commit ('setTestToken', payload);
    },
    CHANGE_PAGE_TRANSITION({ commit }, payload) {
        commit ('changePageTransition', payload);
    },
    HIDE_PANEL_TAB({ commit }, payload) {
        commit ('hidePanelTab', payload);
    },
    ADD_FORMATED_CUSTOM_FONTS({ commit }, payload) {
        commit ('addFormatedCustomFonts', payload);
    },
    ALL_ELEMENTS_LOADED({ commit }) {
        commit ('allElementsLoaded');
    },
    ELEMENTS_CHANGING({ commit }, payload) {
        commit ('elementsChanging', payload);
    }
}